import type { ThunkAction, UnknownAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { combineReducers } from 'redux';

import dashboardEditReducer from '@/features/dashboard/state/dashboardEdit.slice';
import { selectionListener } from '@/features/symbol-selector/state/selectionListener';
import { symbolSelectorReducer } from '@/features/symbol-selector/state/symbolSelector.slice';
import { authListener } from '@/store/authListener';
import { permissionListener } from '@/store/permissionListener';
import tripTokenReducer from '@/store/slices/tripToken.slice';
import userReducer from '@/store/slices/user.slice';

import drawerReducer from '@/store/slices/drawer.slice';
import exportReducer from '@/store/slices/export.slice';
import modalReducer from '@/store/slices/modal.slice';

export const rootReducer = combineReducers({
  tripToken: tripTokenReducer,
  user: userReducer,
  symbolSelector: symbolSelectorReducer,
  modal: modalReducer,
  drawer: drawerReducer,
  export: exportReducer,
  dashboardEdit: dashboardEditReducer
});

export const store = configureStore({
  // process.env.NODE_ENV === 'development'
  devTools: import.meta.env.DEV,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(selectionListener.middleware)
      .prepend(permissionListener.middleware)
      .prepend(authListener.middleware),
  reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  UnknownAction
>;

setupListeners(store.dispatch);
